import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { ShowsDataService, ShowsColumnsService } from '../../../services';
import { Show, ShowsResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-show-details',
  templateUrl: './show-details.component.html',
  styleUrls: ['./show-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class ShowDetailsComponent implements OnInit, OnDestroy {

  public show: Show = {};
  public shows: Show[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private showsDataService: ShowsDataService,
    private showsColumnsService: ShowsColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Show - Details');
        this.getShow(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.show !== 'undefined') {
      this.show = this.dynamicDialogConfig.data.show;
    }
    this.columns = this.showsColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getShow(id: number): void {
    this.isLoading = true;
    this.showsDataService.getShow(id).subscribe((response: Show|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.show = response;
      }
    });
  }

  list() {
    this.router.navigate(['/shows']);
  }

  add() {
    this.router.navigate(['/shows/add']);
  }

  edit() {
    this.router.navigate(['/shows/edit/' + this.show.id]);
  }

}
@Component({
  selector: 'app-show-details',
  templateUrl: './show-details.component.html',
  styleUrls: ['./show-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogShowDetailsComponent extends ShowDetailsComponent {
}

